import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import { useOrders } from '../../domains/cabinet/features/orders/orders.provider';

export const CabinetRootPage = () => {
  const { getOrdersRequest } = useOrders();

  useEffect(() => {
    getOrdersRequest.send();
  }, []);

  return <Outlet />;
};
